import { render, staticRenderFns } from "./ChatPaletteItemList.vue?vue&type=template&id=6e826e39&lang=pug&"
import script from "./ChatPaletteItemList.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteItemList.vue"
export default component.exports